import { DayNight, Days, Months } from './citation.models';
import { FILTER_TYPE, Gender, Race } from './filter.models';
import { AgeGroups } from './person.models';
import { IDepartment } from './sharing.models';

export type IWorkupType = 'CITATION' | 'WARNING' | 'FEEDBACK';

export enum CitationColumn {
  Id = 'id',
  Month = 'month',
  Date = 'date',
  Time = 'time',
  DayNight = 'dayNight',
  DayOfWeek = 'dayOfWeek',
  DriverLastName = 'driverLastName',
  DriverFirstName = 'driverFirstName',
  DriverMiddleName = 'driverMiddleName',
  DateOfBirth = 'dateOfBirth',
  Race = 'driverRace',
  Sex = 'driverSex',
  AgeGroup = 'driverAgeGroup',
  ZipCode = 'zipCode',
  City = 'city',
  State = 'state',
  VehicleYear = 'vehicleYear',
  VehicleMake = 'vehicleMake',
  VehicleModel = 'vehicleModel',
  VehicleType = 'vehicleType',
  VehicleColor = 'vehicleColor',
  VehicleState = 'vehicleState',
  LicPlate = 'vehicleLicPlate',
  Officer = 'officer',
  OfficerId = 'officerId',
  CitationType = 'citationType',
  IssueType = 'issueType',
  OffenceCode = 'offenceCode',
  PhoneNumberCaptured = 'phoneNumberCaptured',
  Department = 'department',
}

export interface IAllDataResponse {
  content: ICitationDetailsV2[];
  totalPages: number;
  totalElements: number;
  last: boolean;
  size: number;
}

export interface IViolation {
  id: number;
  name: string;
  policeCode: string;
  type: issueType;
}

export interface ICitationDetails {
  id: string;
  referenceNumber: string;
  department: IDepartment;
  time?: string;
  month: Months;
  date?: string;
  dateTime: string;
  dayNight: DayNight;
  dayOfWeek: Days;
  driver: {
    id: number;
    firstName: string;
    lastName: string;
    middleName: string;
    sex: Gender;
    race: Race;
    dateOfBirth: string;
    ageGroup: AgeGroups;
    age: number;
    hasPhoneNumber: boolean;
  };
  location: {
    address: string;
    zipCode: string;
    city: string;
    state: string;
  };
  officer: {
    id: number;
    firstName: string;
    lastName: string;
    middleName: string;
    officerNumber: string;
  };
  vehicle: {
    color: string;
    model: string;
    make: string;
    type: string;
    year: string;
    licPlate: string;
    state: string;
  };
  stopDetails: {
    reasonForStop: string;
    reasonForSearch: string;
    contrabandOrEvidence: string;
    resultOfTheStop: string;
  };
  violations: Array<IViolation>;
}

export type issueType = 'WARNING' | 'CITATION';

export interface ICitationDetailsV2 extends ICitationDetails {
  citationType?: string;
  issueType?: issueType;
  offenceCode?: string;
  isDuplicated?: boolean;
  citationId: string;
}

export interface ICitationTableColumns {
  columnDef: CitationColumn;
  header: string;
  cell: (value: ICitationDetailsV2) => string;
  filterType?: FILTER_TYPE;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options?: any;
  isSingle?: boolean;
  sortDef?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  save?: (value: any) => void;
}
